/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import {Modal, Card, Icon, Avatar, List, Spin, Input, message, Divider, Upload, Button} from 'antd';
import PropTypes from 'prop-types';
import Editor from './Editor';
import Editors from '../../view/components/editor/Editors'
import {Scrollbars} from "react-custom-scrollbars";
import * as utils from "../../utils";
import {checkContent} from "../../actions/weiBo";
import UploadWall from "../upload/UploadWall";
const {TextArea} = Input;

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG文件！');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('Image must smaller than 20MB!');
    }
    return isJpgOrPng && isLt2M;
}

export default class Headlines extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            initWeiBoId:0,
            title: '',
            summary: '',
            content: '',//头条内容
            isUpDate: false,
            cover: '',//封面图
            contents: '',//微博主体内容
            labelNames: [],//标签名字
            timingTransmission: '',//定时发送的时间暂存,
            currentData:{},//微博所有的数据

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">设置封面</div>
            </div>
        );
        const {cover} = this.state;
        let height = "calc(65vh - " + "32px)";
        return (
            <div>
                <Modal
                    title="头条文章"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={840}
                    bodyStyle={{padding: 20}}
                    footer={null}
                >
                    <div style={{height: '65vh',}} >
                        <div style={{height: height,overflow:'hidden'}}>
                            <Scrollbars ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }} >
                                <div style={{overflow:'hidden'}}>
                                    <div style={{display: 'flex', height: 100}}>
                                        <div><TextArea placeholder={'请输入标题'} rows={2}
                                                       style={{width: 700, fontSize: 22, height: 100,resize: 'none'}} maxLength={32}
                                                       value={this.state.title}
                                                       onChange={(e) => {
                                                           this.setState({title: e.target.value})
                                                       }}
                                        /></div>
                                        <div style={{lineHeight: '180px', marginLeft: 20}}>{this.state.title.length}/32
                                        </div>
                                    </div>
                                    <div style={{display: 'flex', marginTop: 20}}>
                                        <div><Input placeholder="导语(选填)" style={{width: 700,}} maxLength={44}
                                                    value={this.state.summary}
                                                    onChange={(e) => {
                                                        this.setState({summary: e.target.value})
                                                    }}
                                        /></div>
                                        <div
                                            style={{
                                                lineHeight: '50px',
                                                marginLeft: 20
                                            }}>{this.state.summary.length}/44
                                        </div>
                                    </div>
                                    <div  style={{width:780}}>
                                       {/* <Editor
                                            customHeight={this.props.customHeight}
                                            content={this.state.content}
                                            isUpDate={this.state.isUpDate}
                                            callBackeditorContent={(data) => {
                                                // console.log(data)
                                                this.setState({content: data, isUpDate: false})
                                            }}
                                        />*/}
                                        <Editors
                                            customHeight={500}
                                            imgBtnShow={true}
                                            content={this.state.content}
                                            isUpDate={this.state.isUpDate}
                                            dataSourceType={7}
                                            callBackeditorContent={(data) => {

                                                this.setState({content: data, isUpDate: false})
                                            }}
                                        />
                                    </div>
                                    <Divider style={{fontSize: 12, color: '#808080'}}>发布设置</Divider>
                                    <div style={{display: 'flex'}}>
                                        <div style={{fontSize: 16, color: '#333333'}}>设置封面</div>
                                        <div style={{marginLeft: 20}}>
                                            <Upload
                                                name="file"
                                                listType="picture-card"
                                                className="avatar-uploader"
                                                showUploadList={false}
                                                action="/cm-sites-pms/ueditor/control?action=uploadimage"
                                                beforeUpload={beforeUpload}
                                                data={{dataSource:7}}
                                                onChange={this.handleChange.bind(this)}
                                            >
                                                {cover ? <img src={cover} alt="avatar" style={{
                                                    maxWidth: '128px',
                                                    maxHeight: '128px'
                                                }}/> : uploadButton}
                                            </Upload>
                                        </div>
                                    </div>
                                </div>
                            </Scrollbars>
                        </div>
                        <div style={{marginTop:10}}>
                            <Button type="primary" style={{float: 'right'}} onClick={() => {
                                this.nextBtn()
                            }}>下一步</Button>
                        </div>
                        <div style={{clear: 'both'}}/>
                    </div>
                </Modal>
            </div>
        )
    }

    //开启私信
    showModal = (parms = {}) => {
       // console.log(parms);
        if (parms.isAdd) {
            //新增
            this.state.isUpDate = false;
            this.state.content = '';
            this.state.title = '';
            this.state.summary = '';
            this.state.content = '';//头条内容
            this.state.isUpDate = true;
            this.state.cover = '';//封面图
            this.state.contents = '';//主体内容
            this.state.labelNames = [];//标签名字
            this.state.initWeiBoId=-1;
            this.state.timingTransmission = '';//定时发送的时间暂存
        } else {
            //再次编辑头条文章 从微博发布里面点击头条文章图片跳转过来的编辑内容
            this.state.currentData={...parms};
            this.state.isUpDate = true;
            this.state.initWeiBoId=parms.initWeiBoId;
            this.state.content = parms.touTiaoArticle.content;
            this.state.title = parms.touTiaoArticle.title;
            this.state.summary = parms.touTiaoArticle.summary;
            this.state.content = parms.touTiaoArticle.content;//头条内容
            this.state.isUpDate = true;
            this.state.cover = parms.touTiaoArticle.cover;//封面图
            this.state.contents = parms.content;//主体内容
            this.state.labelNames =parms.labelNames;//标签名字
            this.state.timingTransmission = parms.timingTransmission;//定时发送的时间暂存
        }
        //滚动条每次都在最顶部。延迟是为了解决没有this.scrollRef这个的问题
       setTimeout(() => {
           this.scrollRef && this.scrollRef.scrollToTop();
        });
        this.state.visible = true;
        this.setState({})
    };

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // getBase64(info.file.originFileObj, cover =>
            //     this.setState({
            //         cover,
            //         loading: false,
            //     }),
            // );
            let fileInfo = info.file.response;
            //console.log(fileInfo);
            this.setState({
                cover: fileInfo.url,
                loading: false,
            })
        }
    };

    //下一步
    nextBtn() {

        if (this.state.title.trim().length === 0) {
            message.warn('请输入标题');
            return;
        }
        if (this.state.cover.trim().length === 0) {
            message.warn('请上传封面');
            return;
        }
        if (this.state.content.trim().length === 0||this.state.content.trim()==="<p></p>") {
            message.warn('请输入正文');
            return;
        }
        // 验证文章中资源地址
        checkContent(this.state.content,(res)=>{
            if(res.data && res.data.length > 0){
                message.warn("当前文章中的图片或其他资源包含非融媒体系统地址，请确认！")
            }else {
                let parms = {
                    ...this.state.currentData,//复制所有传值，再用下面新的值去覆盖。
                    content: this.state.contents.length>0?this.state.contents:"发布了头条文章：《" + this.state.title + "》",
                    labelNames: this.state.labelNames,//标签名字
                    timingTransmission: this.state.timingTransmission,//定时发送的时间暂存
                    initWeiBoId:this.state.initWeiBoId,//为头条文章带过去的参数；大于0 ，微博编辑的实际微博Id.区别发出去的微博头条，还是新增的微博头条。
                    touTiaoArticle: {
                        content: this.state.content,
                        cover: this.state.cover,
                        title: this.state.title,
                        summary: this.state.summary,
                    },
                };
                this.state.visible = false;
                this.setState({});
                this.props.callback && this.props.callback(parms);
            }
        });
    }

}
